
document.addEventListener("DOMContentLoaded", () => {
  // Replace Size Guide tab with custom trigger
  const observer = new MutationObserver(() => {
    const sizeGuideTabButton = [...document.querySelectorAll(".product-tabs__nav-button")]
      .find(btn => btn.textContent.trim().includes("Size Guide"));
    const sizeGuideTrigger = document.querySelector("#size-guide-trigger");
    
    if (sizeGuideTabButton && sizeGuideTrigger) {
    if(product.tags.includes("accessories")){
      sizeGuideTrigger.style.display = "none";

    }else{
        sizeGuideTabButton.replaceWith(sizeGuideTrigger);
        observer.disconnect();
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  fetchSizeChart();
});

function renderSizeChart(data, container) {
  let unit = "inches";
  const headingsArray = Object.keys(data?.[0]).filter(h => h !== "size");
 

  const toggleContainer = document.createElement("div");
  toggleContainer.className = "toggle-container";
  toggleContainer.style.cssText = `
    display:flex; align-items:center; gap:10px; margin:20px 0; justify-content:end;
  `;

  toggleContainer.innerHTML = `
    <span>IN</span>
    <label class="toggle-switch" style="position:relative; display:inline-block; width:50px; height:24px;">
      <input type="checkbox" id="unitToggle" style="opacity:0; width:0; height:0;">
      <span class="slider" style="
        position:absolute; cursor:pointer; top:0; left:0; right:0; bottom:0; 
        background-color:#e0e0e0; transition:0.4s; border-radius:24px;">
        <span id="sliderCircle" style="
          position:absolute; height:18px; width:18px; left:3px; bottom:3px; 
          background-color:#2a2a2a; transition:0.4s; border-radius:50%;">
        </span>
      </span>
    </label>
    <span>CM</span>
  `;

  const tableWrapper = document.createElement("div");

  const buildTable = () => {
    const conversionFactor = unit === "inches" ? 1 : 2.54; // Conversion factor
    tableWrapper.innerHTML = `
      <table border="1" cellspacing="0" cellpadding="8" 
             style="border-collapse:collapse; text-align:center; width:100%;">
        <thead>
          <tr>
            <th>FOLK SAINT SIZE</th>
            ${headingsArray.map(h => `<th>${h.toUpperCase()} (${unit})</th>`).join("")}
          </tr>
        </thead>
     <tbody>
     ${data.map(item => {
      return `
        <tr>
          <td>${item.size}</td>
          ${headingsArray.map(h => {
            const value = item[h]?.inches;
            if (!value || !value.includes("-")) return `<td>-</td>`;
    
            const [min, max] = value.split("-").map(v => parseFloat(v.trim()));
            if (isNaN(min) || isNaN(max)) return `<td>-</td>`;
            const convertedMin = unit === "inches" ? min * conversionFactor  : (min * conversionFactor).toFixed(0);
            const convertedMax =unit === "inches" ? max * conversionFactor  : (max * conversionFactor).toFixed(0);
            const conversionValue = `${convertedMin} - ${convertedMax}`;
            return `<td>${conversionValue}</td>`;
          }).join("")}
        </tr>
      `;
    }).join("")}
    
      </tbody>

      </table>
    `;
  };

  container.innerHTML = "";
  container.append(toggleContainer, tableWrapper);
  buildTable();

  // Toggle handler
  const toggle = toggleContainer.querySelector("#unitToggle");
  const sliderCircle = toggleContainer.querySelector("#sliderCircle");

  toggle.addEventListener("change", () => {
    unit = toggle.checked ? "cm" : "inches";
    sliderCircle.style.transform = toggle.checked ? "translateX(26px)" : "translateX(0)";
    buildTable();
  });
}

function fetchSizeChart() {
  const modal = document.querySelector("modal-dialog#CollapsiblePopupModal-collapsible_tab_WhrWVD");
  const sizeChart = modal?.querySelector("#size-chart");
  if (!sizeChart) return;

  fetch(sizeChartUrl)
    .then(res => res.json())
    .then(data => {
      const productCatagory = productTitle.split("-")[0];
      renderSizeChart(data[productCatagory], sizeChart);
    });
}

function toggleInternationalSizeChart(toggle) {
  const modal = document.querySelector("modal-dialog#CollapsiblePopupModal-collapsible_tab_WhrWVD");
  const sizeChart = modal?.querySelector("#size-chart");
  if (!sizeChart) return;

  if (toggle === "intMeasurements") {
    const cellStyle = "border:1px solid #291b0d33; padding:8px;";
    const headerStyle = `${cellStyle} font-weight:bold;`;
    let productInterSizeList = []
    const internationalChartArray = [
      ["XXS", "32", "0", "4", "30", "36", "3", "34", "38"],
      ["XS", "34", "2", "6", "32", "38", "5", "36", "40"],
      ["S", "36", "4", "8", "34", "40", "7", "38", "42"],
      ["M", "38", "6", "10", "36", "42", "9", "40", "44"],
      ["L", "40", "8", "12", "38", "44", "11", "42", "46"],
      ["XL", "42", "10", "14", "40", "46", "13", "44", "48"],
      ["XXL", "44", "12", "16", "42", "48", "15", "46", "50"],
      ["XXXL", "46", "14", "18", "44", "50", "17", "48", "52"],
      ["XXXXL", "48", "16", "20", "46", "52", "19", "50", "54"],
    ]
    fetch(sizeChartUrl)
      .then(res => res.json())
      .then(data => {
        const productCatagory = productTitle.split("-")[0];
        productInterSizeList = data[productCatagory]

        let availavleInternationalSizes = []
        internationalChartArray.forEach((size) => {
          productInterSizeList.forEach((product) => {
            let usSize = product.size.split("-")?.[1]
            if (usSize?.slice(0, -1) === size[2]) {
              availavleInternationalSizes.push(size)
            }

          })
        })

        sizeChart.innerHTML = `
        <div style="max-width:100%; margin-bottom:20px auto; padding:10px;">
          <h1 style="text-align:center;" class="h2">Dresses</h1>
          <span style="display:block; text-align:center; margin-bottom:20px;">These are the measurements Sézane dresses correspond to</span>
          <table style="width:100%; border-collapse:collapse; text-align:center; font-size:14px;">
            <thead>
              <tr>
                <th style="${headerStyle}">Size</th>
                <th style="${headerStyle}">France, Spain, Portugal</th>
                <th style="${headerStyle}">United States</th>
                <th style="${headerStyle}">United Kingdom & Australia</th>
                <th style="${headerStyle}">Germany, Denmark & Switzerland</th>
                <th style="${headerStyle}">Italy</th>
                <th style="${headerStyle}">Japan</th>
                <th style="${headerStyle}">Brazil</th>
                <th style="${headerStyle}">Russia</th>
              </tr>
            </thead>
            <tbody>
                ${availavleInternationalSizes.map(row => `
                <tr>${row.map(cell => `<td style="${cellStyle}">${cell}</td>`).join("")}</tr>
              `).join("")}
            </tbody>
          </table>
        </div>
      `;

      });

  } else {
    fetchSizeChart();
  }
}

const handleSwitcherClick = (e) => {
  const siblings = e.target.parentNode.children;
  for (let sibling of siblings) {
    if (sibling !== e.target) {
      console.log("sib>>>>>>>>>",sibling);
      
      sibling.style.textDecoration = "none";
    }
  }
  e.target.style.textDecoration = "underline";

}